import React from 'react';

const About = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Sobre</h1>
      <p>Informações sobre o projeto Elion e Zimmo.</p>
    </div>
  );
};

export default About;
